export const getElementWidth = (id: string) => {
    const element = document.getElementById(id)
    return element ? element.clientWidth : 0
}
